import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, EDIT } from "const"
import { MtStudyTeamMember } from "server/models"
import { StateType, deepCopy, hasProjectAccess } from "client/utils"
import {
    PRM_STUDY,
    StoreType,
    StudyProps,
    StudyTeamMemberList,
    StudyTeamMemberFilters,

    LoadAllStudyTeamMembers,
    DeleteStudyTeamMember,
    SortStudyTeamMembers,

    setStudyTeamMemberList,
    setStudyTeamMemberIds,
    setStudyTeamMemberSort,
    setStudyTeamMemberFilters,
    addModal,
} from "client/store"
import {
    PageContent,
    Loader,
    Button,
    Table,
    TableSearchWrapper,
    SortRows,
    DeleteRow,
} from "client/components"

import StudyTeamMemberSearch from "client/pages/search/studyTeamMemberSearch"
import Columns from "./columns"
import Edit from "../edit"

const List = ({
    studyId = null,
}: StudyProps) => {
    const teamMemberList = useSelector((state: StoreType) => state.studyTeamMember.teamMemberList)
    const teamMemberIds = useSelector((state: StoreType) => state.studyTeamMember.teamMemberIds)
    const sortColumn = useSelector((state: StoreType) => state.studyTeamMember.sortColumn)
    const sortOrder = useSelector((state: StoreType) => state.studyTeamMember.sortOrder)
    const filters = useSelector((state: StoreType) => state.studyTeamMember.filters)
    const reloadList = useSelector((state: StoreType) => state.studyTeamMember.reloadList)

    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!reloadList) return
        setLoadState(PENDING)
        LoadAllStudyTeamMembers(studyId).then((res) => {
            dispatch(setStudyTeamMemberList(res))
            setLoadState(IDLE)
        })
    }, [reloadList])

    useEffect(() => {
        const sortedIds = SortStudyTeamMembers(Object.values(teamMemberList), sortColumn, sortOrder, filters)
        dispatch(setStudyTeamMemberIds(sortedIds))
    }, [teamMemberList, sortColumn, sortOrder, filters])

    const onSort: SortRows = (column: keyof MtStudyTeamMember, order) => {
        dispatch(setStudyTeamMemberSort(column, order))
    }

    const onFilter = (newFilters: StudyTeamMemberFilters) => {
        dispatch(setStudyTeamMemberFilters(newFilters))
    }

    const onDelete: DeleteRow = (teamMember: MtStudyTeamMember, callback) => {
        DeleteStudyTeamMember(teamMember.id, studyId).then((removedRows) => {
            const success = removedRows === 1
            callback(success, () => {
                const teamMemberListCopy: StudyTeamMemberList = teamMemberList ? deepCopy(teamMemberList) : {}
                delete teamMemberListCopy[teamMember.id]
                dispatch(setStudyTeamMemberList(teamMemberListCopy))
                dispatch(setStudyTeamMemberIds(teamMemberIds.filter((id) => id !== teamMember.id)))
            })
        })
    }

    const columns = Columns()
    const editStudyAccess = hasProjectAccess(PRM_STUDY, EDIT)

    return (
        <PageContent>
            {
                loadState === PENDING
                && <Loader />
            }
            <TableSearchWrapper>
                <StudyTeamMemberSearch
                    id="teamMemberList"
                    rightOffset={editStudyAccess}
                    filters={filters}
                    onFilter={onFilter}
                />
                {
                    editStudyAccess && (
                        <Button
                            variant="success"
                            onClick={() => dispatch(addModal({
                                key: "addTeamMember",
                                content: <Edit teamMemberId={0} />,
                            }))}
                        >
                            {lang.add}
                        </Button>
                    )
                }
            </TableSearchWrapper>
            <Table
                columns={columns}
                dataList={teamMemberList}
                dataIds={teamMemberIds}
                sortColumn={sortColumn}
                sortOrder={sortOrder}
                rowSize="md"
                showPagination
                onSort={onSort}
                onDelete={onDelete}
            />
        </PageContent>
    )
}
export default List
